/* PAYRESPECTS V3 ASCOLOUR — mobile parity helpers (Matt's phone reference captures, 2026-10-15).
   1. Dismissible announcement bar (per session).
   2. Product page ≤749px: breadcrumb + title + price move below the gallery (Matt, 2026-10-24); quantity + add-to-cart become a
      fixed bottom bar. Inputs keep their form association (form="…"), so the cart contract is unchanged. */
(function () {
  'use strict';

  /* 1. announcement close */
  var ann = document.querySelector('.announcement-bar');
  if (ann) {
    var wrap = ann.closest('.shopify-section') || ann;
    var closed = false;
    try { closed = sessionStorage.getItem('v3-ann-closed') === '1'; } catch (e) {}
    if (closed) {
      wrap.hidden = true;
    } else if (!ann.querySelector('.v3-ann-close')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'v3-ann-close';
      btn.setAttribute('aria-label', 'Close announcement');
      btn.innerHTML = '<svg viewBox="0 0 18 18" width="14" height="14" aria-hidden="true" focusable="false"><path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
      btn.addEventListener('click', function () {
        wrap.hidden = true;
        try { sessionStorage.setItem('v3-ann-closed', '1'); } catch (e) {}
      });
      ann.appendChild(btn);
      ann.classList.add('v3-ann--closable');
    }
  }

  /* 2. mobile product page */
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  var product = document.querySelector('.product');
  var info = document.querySelector('.product__info-container');
  var media = document.querySelector('.product__media-wrapper');
  if (!product || !info || !media) return;

  var crumb = info.querySelector('.v3-breadcrumb');
  var title = info.querySelector('.product__title');
  var price = info.querySelector('[id^="price-"]');
  if (title) {
    var head = document.createElement('div');
    head.className = 'v3-pdp-head grid__item';
    if (crumb) head.appendChild(crumb);
    head.appendChild(title);
    if (price) head.appendChild(price);
    media.parentNode.insertBefore(head, media.nextSibling);
  }

  var qty = info.querySelector('.product-form__quantity');
  var form = info.querySelector('product-form');
  // The simple mockneck template keeps its buy form inline; assets/pr-mockneck-buy.js adds its own bar.
  // PR 2026-10-26: product pages that render snippets/pr-mobile-pdp.liquid ([data-prm-root]) keep the buy form inline with their own scroll-in bar.
  if (form && !document.body.classList.contains('template-product-simple') && !document.querySelector('[data-prm-root]')) {
    var bar = document.createElement('div');
    bar.className = 'v3-sticky-buy';
    if (qty) bar.appendChild(qty);
    bar.appendChild(form);
    (document.querySelector('product-info') || product).appendChild(bar);
    document.body.classList.add('v3-has-sticky-buy');
  }
})();

// PR 2026-10-24: "You may also like" reserves its height (v3-theme.css) so the footer doesn't jump; release it if no recommendations arrive.
(function () {
  var recs = document.querySelectorAll('product-recommendations.related-products');
  if (!recs.length) return;
  setTimeout(function () {
    recs.forEach(function (el) { if (!el.querySelector('.grid__item')) el.classList.add('pr-recs-empty'); });
  }, 6000);
})();

// PR 2026-10-24: line the desktop mega menu columns up with the first nav item (header is full width, so a fixed offset drifts).
(function () {
  var nav = document.querySelector('.header__inline-menu .list-menu__item, .header__inline-menu summary, .header__inline-menu a');
  if (!nav) return;
  function place() { document.documentElement.style.setProperty('--pr-nav-x', Math.round(nav.getBoundingClientRect().left + 12) + 'px'); }
  place();
  window.addEventListener('resize', place);
  window.addEventListener('load', place);
})();
